import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import QRCode from "qrcode";

// Hilfsfunktion für JSON-Export
export function exportPlanJSON(items, info) {
  const data = { items, info };
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `trainingsplan${info.title ? "_" + info.title : ""}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function exportPlanPDF(items, info) {
  const doc = new jsPDF("p", "mm", "a4");
  const vereinsrot = "#FC0B0B";
  const vereinsrotDunkel = "#a30505";
  const vereinsrotSoft = "#fc8181";

  // Logo laden
  const logoUrl = "/img/logo/Logo einzeln freigestellt ohne Hintergrund rot.png";
  const img = new Image();
  img.src = logoUrl;

  img.onload = async () => {
    // Logogröße
    const maxWidth = 40;
    const maxHeight = 25;
    let width = img.width;
    let height = img.height;
    const ratio = Math.min(maxWidth / width, maxHeight / height);
    width *= ratio;
    height *= ratio;

    // Kopfzeile
    doc.addImage(img, "PNG", 10, 3, width, height);
    doc.addImage(img, "PNG", 200 - width, 3, width, height);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.setTextColor(vereinsrot);
    doc.text(
      `Trainingsplan${info.title ? "\n" + info.title : ""}`,
      105,
      15,
      { align: "center" }
    );

    // Trainingsinfos
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`Altersklasse: ${info.ageClass || "-"}`, 14, 38);
    doc.text(`Gesamtdauer: ${info.duration || 0} min`, 14, 45);

    // Tabellen-Daten vorbereiten
    const tableBody = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      let link = null;
      let qrDataUrl = null;

      if (item.type !== "pause" && item.website) {
        link = `https://www.radball-ludwigsfelde.de/uebungen#${item.website}`;
        qrDataUrl = await QRCode.toDataURL(link, { width: 64, margin: 0 });
      }

      tableBody.push([
        i + 1,
        item.type === "pause" ? "Pause" : item.Titel,
        item.Wiederholung || "",
        item.Intensität || "",
        `${item.dauer} min`,
        { content: "", qrImage: qrDataUrl },
      ]);
    }

    autoTable(doc, {
      head: [["#", "Titel", "Wdhl", "Intensität", "Dauer", "QR"]],
      body: tableBody,
      startY: 55,
      rowPageBreak: "avoid",
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: 100, halign: "left" },
        2: { cellWidth: 15, halign: "center" },
        3: { cellWidth: 22, halign: "center" },
        4: { cellWidth: 15, halign: "center" },
        5: { cellWidth: 20, halign: "center" },
      },
      styles: {
        font: "helvetica",
        fontSize: 11,
        lineColor: vereinsrotSoft,
        lineWidth: 0.2,
        valign: "middle",
        minCellHeight: 20,
      },
      headStyles: {
        fillColor: vereinsrotDunkel,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
        height: 5,
      },
      alternateRowStyles: {
        fillColor: "#f9f9f9",
      },
      didParseCell: (data) => {
        const item = items[data.row.index];
        if (data.section === "body" && item?.type === "pause") {
          data.cell.styles.fillColor = "#f0f0f0";
          data.cell.styles.textColor = [0, 0, 0];
          data.cell.styles.fontStyle = "italic";
        }
      },
      didDrawCell: (data) => {
        const rowData = data.row.raw;
        const item = items[data.row.index];

        // QR-Code nur zeichnen, wenn qrImage existiert
        if (
          data.column.index === 5 &&
          data.section === "body" &&
          rowData[5] &&
          rowData[5].qrImage
        ) {
          const qrSize = 15;
          const x = data.cell.x + (data.cell.width - qrSize) / 2;
          const y = data.cell.y + (data.cell.height - qrSize) / 2;

          doc.addImage(rowData[5].qrImage, "PNG", x, y, qrSize, qrSize);

          if (item?.type !== "pause" && item?.website) {
            const link = `https://www.radball-ludwigsfelde.de/uebungen#${item.website}`;
            doc.link(x, y, qrSize, qrSize, { url: link });
          }
        }
      },
    });

    doc.save(`trainingsplan${info.title ? "_" + info.title : ""}.pdf`);
  };
}
